export default {
  // 页面标题
  title: 'Aha',
  newCampaign: '新建营销计划',

  // AI代理
  aiAgent: {
    placeholder: '如有任何问题，请随时打断我提问',
  },

  // 模态框标题
  modalTitles: {
    paymentDetails: '付款详情',
  },

  // 按钮文本
  buttons: {
    saveDraft: '保存草稿',
    next: '下一步',
    update: '更新',
    release: '发布',
    signUpForMore: '免费注册，解锁更多',
    saveAndExit: '保存计划并退出编辑',
  },

  // 帮助提示
  help: {
    whatHappensAfterPublish: '发布后会发生什么？',
    skipStepTooltip: '对当前计划信息很有把握？可跳过此步，直接进入下一步。',
  },

  // 关闭确认模态框
  closeModal: {
    title: '未保存的更改',
    description: '您有未保存的更改，确定要退出吗？',
    notSaved: '未保存',
  },

  // 消息提示
  messages: {
    rechargeFailed: '充值失败',
    rechargeSuccessful: '充值成功！余额已更新。',
  },

  // 错误消息
  errors: {
    getCampaignDetailFailed: '获取计划详情失败',
    bindOrgFailed: '组织绑定失败',
    networkError: '网络错误。请刷新页面后重试。',
  },

  // 产品类型
  productType: {
    webApp: 'Web 应用',
    mobileApp: '移动应用',
    desktopApp: '桌面应用',
    browserExtension: '浏览器插件',
    physicalProduct: '实体产品',
  },

  // 业务模式
  businessModel: {
    toBusiness: '面向企业',
    toCustomer: '面向消费者',
    b2b: 'B2B',
    b2c: 'B2C',
  },

  // 活动目标
  campaignObjective: {
    awareness: '品牌知名度',
    websiteTraffic: '网站流量',
    installs: '下载安装',
    leads: '客户留资',
    signUps: '用户注册',
    sales: '用户付费',
  },

  // 活动目标子类型
  campaignObjectiveSubType: {
    subscription: '订阅',
    payAsYouGo: '按需付费',
    oneTimePayment: '一次性付费',
  },

  // 目标表单标签
  targetForm: {
    installs: {
      title: '点击-安装转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：60%-80%。',
      message: '请输入点击-安装转化率',
    },
    signUps: {
      title: '点击-注册转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：20%-50%。',
      message: '请输入点击-注册转化率',
    },
    leads: {
      title: '点击-留资转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：1%-5%。',
      message: '请输入点击-留资转化率',
    },
  },

  // 目标选项
  targetOptions: {
    traffic: {
      title: '流量',
      desc: '把合适的受众引导至您的目标页，如网站、App、社媒主页等。将跟踪链接点击（PV）。',
    },
    leads: {
      title: '线索',
      desc: '为您的品牌收集销售线索，促使用户采取行动。',
    },
  },

  // 成功模态框
  successModal: {
    congratulations: '恭喜！计划已创建。审核通过后 24–48 小时内将收到达人的申请。',
    congratulationsColdEmail: '恭喜！计划已创建。',
    descriptionGuide: '同时可先了解 Aha 的关键用法和使用技巧，帮助您最大化营销效果',
    descriptionColdEmail: '我们正在为您配置邮箱域名与账户。预热通常至少需要 7 天，完成后将开始发送邀请。',
    descriptionNormal: '您也可以先查看活动详情，或了解 Aha 的关键用法以取得更好效果',
    viewCampaign: '查看营销计划',
    importantSeeNext: '重要：接下来会发生什么',
    checkHeadInstructions: '查看 Aha 使用指南',
  },

  // 高级设置
  advancedSetting: {
    title: '高级设置',
  },

  // 设置页面
  settings: {
    title: '设置',
    save: '保存',
    cancel: '取消',
    saveSuccess: '保存成功！',
    placements: '投放位置',
    languages: '语言',
    locations: '地区',
    influencerMarketingPostDate: '达人营销发布时间',
    affiliateMarketingContentPostDate: '分销内容发布时间',
    landingPageLink: '请提供用户点击后到达的页面链接',
    selectAll: '全选',
    pleaseSelectAtLeastOnePlatform: '请至少选择一种平台内容类型',
    pleaseSelectAtLeastOneRegion: '请至少选择一个地区',
    pleaseSelectPostDate: '请选择发布时间',
    flexiblePostTime: '弹性发布时间：达人在内容通过审核后即可发布。',
    fixedPostTime: '固定发布时间：达人需在指定时间窗口内发布内容。',
    selectCampaignStartDates: '建议至少提前 1 个月开始活动，以便达人有充足时间制作内容。',
    influencersRequiredToPost: '达人在申请通过后需于 7 天内发布内容',
    currentSelectionMayLimit: '当前选择可能限制达人的匹配范围。为获得更好结果，建议增加平台、语言或地区以扩大覆盖。',
    selectedPlatformsMayLimit: '所选平台可能限制活动触达。为提升表现，请考虑增加平台类型。',
    chooseSocialPlatforms: '选择达人的平台和内容形式',
    enterLanguageToShowAds: '选择您想要投放的受众语言。',
    chooseBroadAreaToShowAds: '选择更广的展示地区通常能带来更好结果。',
    specifyParticularDateWindow: '如需达人在特定时间段发布，请在此指定。',
    trackingLinkDescription: 'Aha 会基于此链接为每位达人生成唯一追踪链接，以便统计点击与表现。（例如: 浏览量、点击量、CPM和CPC等）',
    coldEmailSettings: '邮件',
    emailSenderName: '发件人名称',
    letAIAgentSetCPM: '让 Agent设定 CPM',
    letAIAgentSetCPMDesc: '由 Agent 为您设定 CPM，适用于没有 CPM 上限的品牌。',
    smartMode: '智能模式',
    setMaximumCPMManually: '手动设置最大 CPM',
    setMaximumCPMManuallyDesc: '手动设定 CPM 上限，适用于有严格 CPM 上限的品牌。',
    manualMode: '手动模式',
    letAIAgentNegotiatePrice: '让 Agent 协商价格',
    letAIAgentNegotiatePriceDesc: '由 Agent为您争取最优价格，适用于单个达人预算不设上限的品牌。',
    setPriceLimitsManually: '手动设置价格范围',
    setPriceLimitsManuallyDesc: '手动设定达人预算上限/下限，适用于预算严格受限的品牌。',
    highestBudgetPerInfluencer: '单个达人最高预算',
    lowestBudgetPerInfluencer: '单个达人最低预算',
    emailSenderTitle: '发件人头衔',
    emailToForwardConvertedLeads: '线索转交邮箱',
    pleaseEnterEmailSenderName: '请输入发件人名称',
    pleaseEnterEmailSenderTitle: '请输入发件人头衔',
    pleaseEnterEmailSenderForwardEmail: '请输入线索转交邮箱',
    pleaseEnterValidName: '请输入有效名称',
    pleaseEnterValidEmailAddress: '请输入有效邮箱地址',
    advancedInfluencerSettings: '高级达人设置',
    influencerFilterWarning: '请注意，应用达人筛选逻辑将限制您的达人供应。请谨慎设置。',
    influencerSettings: {
      performanceActivity: '表现与活跃度',
      minimumPredictedViews: '最低预测浏览量',
      minimumPredictedViewsTooltip: 'Aha 使用历史数据预测达人的浏览量。如果不设置，默认预测浏览量阈值为 YouTube: 400, TikTok: 1500, Twitter: 700, LinkedIn: 500, Instagram: 1500',
      minimumFollowers: '最低粉丝数',
      postingFrequency: '发布频率',
      postingFrequencyRequired: '请输入发布频率',
      postsPerMonth: '次/月',
      lastPostTime: '最后发布时间',
      lastPostTimeRequired: '请输入最后发布时间',
      lastPostTimePlaceholder: '最后发布在 xx 天内',
      price: '价格',
      maximumCpm: '最高 CPM',
      maximumPricePerInfluencer: '单个达人最高价格',
      minimumPricePerInfluencer: '单个达人最低价格',
      audience: '受众',
      audienceGender: '受众性别',
      genderRequired: '请选择性别',
      female: '女性',
      male: '男性',
      percentRequired: '请输入百分比',
      audienceGenderDesc: '选择达人受众中的主要性别及所需的最低百分比。',
      audienceAge: '受众年龄',
      ageRangeRequired: '请选择年龄范围',
      audienceAgeDesc: '选择一个或多个年龄范围及所需的最低受众百分比。',
    },
    emailSenderNamePlaceholder: '该名称将作为冷邮件的发件人名称',
    emailSenderTitlePlaceholder: '该头衔将与发件人名称一同显示',
    emailForwardPlaceholder: '我们会将优质的转化线索转发至该邮箱',
    developedEnglishSpeakingMarkets: '英语成熟市场',
    developedMarkets: '成熟市场',
    developedAndEmergingMarkets: '成熟 + 新兴市场',
    locationBagsDescription: '点击上方分组可快速添加预设的国家/地区。',
    productExplainerVideo: '产品讲解视频',
    productExplainerVideoDesc: '上传一个介绍您产品/服务的 YouTube 精彩视频，便于达人快速理解您的产品优势，提高接单率。',
    customBrandGuidelines: '自定义合作要求',
    customBrandGuidelinesDesc: '除',
    platformRequirements: '平台规范',
    customBrandGuidelinesDescEnd: '如您已有完整的 brief，也可在此一并补充。',
    referenceInfluencers: '参考达人',
    referenceInfluencersDesc: '上传您喜欢的达人列表，Aha 将为您的活动寻找相似达人。',
    downloadTemplate: '下载模板',
    blocklist: '屏蔽名单',
    blocklistDesc: '上传您不希望合作的达人名单。',
    brandAssets: '品牌素材',
    brandAssetsDesc: '通过 Google Drive 或其他网盘上传希望与达人共享的品牌素材。请遵循',
    brandAssetsUploadRequirements: '品牌素材上传要求',
    brandAssetsDescEnd: '以助于达人成品达到更佳效果。',
    add: '添加',
    upload: '上传',
    pleaseInputValidYoutubeLink: '请输入有效的 YouTube 链接！',
    pleaseInputValidLink: '请输入有效链接！',
    pleaseEnterBrandAssetsLink: '请输入品牌素材链接…',
    mustUsePlaceholder: '例如：必须展示 xxx 功能。',
    theFileDoesNotContain: '文件中未包含任何达人资料',
    notice: '提示',
    confirmToAdd: '确认添加',
    notNow: '暂不',
    kindReminder: '温馨提醒',
    youHaveSelectedCountriesOrLanguages: '您已选择以下国家/地区或语言：',
    doYouWantToAddRecommended: '是否同时添加以下推荐的语言或国家/地区？',
    pricingPlan: '计费方案',
    freelancingModel: '外包模式',
    payAsYouGo: '按需付费',
    commissionDescription: '每次与达人合作收取 10% 的服务佣金。',
    employmentModel: '雇佣模式',
    yearly: '年付',
    twoMonthsFree: '每年赠送 2 个月',
    noCommissionsDescription: '不收取佣金，每月按达人营销预算的 7.9% 计费。节省',
    vsPayAsYouGo: '相较按需付费。',
    affiliateMarketing: '分销营销',
    affiliateRecruitmentBudget: '分销招募预算',
    affiliateRecruitmentBudgetDesc: '通过 Aha 招募分销达人的总预算。仅在您确认达人加入时收取；后续佣金在其产生销售后另行结算。常见成本从几美元到 100 美元不等。',
    pleaseSelectBudgetForAffiliate: '请选择预算',
    affiliateCommissionRate: '分销佣金比例',
    pleaseEnterAffiliateCommissionRate: '请输入佣金比例',
    industryBenchmarkCommission: '行业参考：10%–80%',
    averageOrderValue: '平均客单价（AOV）',
    pleaseEnterAverageOrderValue: '请输入平均客单价',
    industryBenchmarkOrder: '行业参考：B2B 50–500 USD，B2C 10–100 USD',
    coldEmail: '冷邮件',
    coldEmailDescription: '发布活动时需支付 30 USD 以覆盖域名搭建、邮箱预热、外联等基础成本。',
    budgetToAcquireConvertedLeads: '获取转化线索预算',
    pleaseSelectBudgetForLeads: '请选择预算',
    positiveResponseRateOutOfSentEmails: '邮件正向回复率',
    pleaseEnterPositiveReplyRate: '请输入正向回复率',
    industryBenchmarkResponseRate: '行业参考：B2B 3%–10%，B2C 1%–5%',
    positiveResponseToPurchaseRate: '正向回复-下单转化率',
    pleaseEnterConversionRate: '请输入转化率',
    industryBenchmarkConversionRate: '行业参考：B2B 8%–25%，B2C 3%–15%',
    averageCustomerLifetimeValue: '平均客户生命周期价值（LTV）',
    pleaseEnterAverageCustomerLifetimeValue: '请输入 LTV',
    // 其他设置相关文本
    placementsInfoModal: {
      title: '平台内容形式与使用场景',
      platform: '平台',
      contentFormat: '内容形式',
      keyFeatures: '使用场景',
      youtubeDedicated: '专题视频',
      youtubeIntegrated: '插片视频',
      instagramReel: 'Reels',
      instagramCarouselPost: '轮播贴',
      tiktokVideo: '视频',
      Posts: '帖子',
      youtubeDedicatedDesc: '全片围绕品牌展开，适用于新品发布、深度评测及品牌故事呈现。',
      youtubeIntegratedDesc: '品牌片段，占创作者视频至少 30% 的内容 — 经济实惠的选项，用于自然但实质性的曝光。',
      instagramReelDesc: '短视频，强大算法触及 — 最佳用于产品发布、病毒趋势和快速品牌曝光。',
      instagramCarouselPostDesc: '最多 10 张幻灯片，混合图像和视频。最佳用于故事叙述、产品演示、比较和教程。',
      tiktokVideoDesc: '垂直短视频混合到用户 feed 中 — 强大的 mass reach、创意故事讲述和年轻受众。',
      linkedinImagePostDesc: '专业图片帖子，带有文本、图像或视频 — 最佳用于 B2B 品牌、招聘和信誉建立。',
      linkedinVideoPostDesc: '达人领衔视频，分享使用案例、专家意见或 testimonials — 强有力的信任建立和决策者之间的参与。',
      linkedinImagePost: 'LinkedIn 图片帖子',
      linkedinVideoPost: 'LinkedIn 视频帖子',
      twitterPostDesc: '灵活帖子，带有文本、图像或视频 — 最佳用于时事关注、品牌声音和病毒传播。',
    },
    twitterPostTooltip: "根据我们过往的经验，Twitter 的表现通常不如其他平台。尽管我们不推荐使用它，但您可以随时联系我们讨论您的营销计划。",
    languageMissPanel: {
      title: '根据您的目标地区，您可能需要添加这些语言：',
      addAll: '添加全部',
    },
    onlyCsvFiles: '仅支持 .csv 文件',
    desiredInfluencerProfiles: '期望达人画像',
    desiredInfluencerProfilesDesc: '期望达人画像描述了您希望合作的达人类型，以便 Aha 能够自动匹配最符合您需求的达人。例如：AI Tools Daily — 擅长解读和介绍新 AI 工具的达人，用清晰、实用的方式分享使用经验。',
    pleaseInputMustDo: '请输入重要事项',
    matchingAccuracy: {
      title: '匹配准确度',
      focusMode: {
        label: '聚焦模式',
        desc: '专注于高度匹配的达人，提升匹配准确度。预期成本更高，活动周期更长。',
      },
      scaleMode: {
        label: '扩展模式',
        desc: '在保持良好相关性的同时扩大达人池——提升效率、降低成本并缩短活动周期。',
      },
      maxScaleMode: {
        label: '最大扩展模式',
        desc: '通过扩大相关性边界最大化触达——大幅降低成本并加速活动周期。',
      },
    },
  },

  // 业务信息
  businessInformation: {
    title: '产品信息',
    companyName: '公司名称',
    website: '官网',
    industry: '行业',
    coreSellingPoints: '核心卖点',
    coreAudiences: '核心产品受众',
    advancedSettings: '高级设置',
    gender: '性别',
    age: '年龄',
    interest: '兴趣',
    aiGeneratedDescription: '以下内容由 Aha 基于品牌分析生成，请按需校对与完善！',
    basicInformation: '基础信息',
    businessLogo: '品牌 Logo',
    logoFormatNote: '仅支持上传 SVG 格式 Logo。',
    upload: '上传',
    businessName: '品牌/企业名称',
    productServiceType: '产品 / 服务类型',
    benchmarkBrands: '对标品牌',
    importantMatters: '重要事项',
    importantMattersDescription: '请在下面填写需要达人特别注意的任何信息，例如：产品使用禁令、需要提及的要点、@tag的帐户等。',
    importantMattersPlaceholder: '请输入达人需要注意的重要事项',
    businessIntroduction: '品牌/业务介绍',
    pleaseEnterBusinessName: '请输入品牌/企业名称',
    pleaseEnterBenchmarkBrands: '请输入对标品牌',
    benchmarkBrandsDescription: '我们会使用您的对标品牌来匹配与这些品牌合作过或触达相似受众的达人。将最相似的品牌放在顶部以提高匹配准确度。',
    pleaseEnterCampaignName: '请输入本次营销计划名称',
    pleaseSelectGender: '请选择性别',
    pleaseSelectAge: '请选择年龄段',
    pleaseEnterInterests: '请输入受众兴趣点，使用英文逗号","分隔',
    pleaseFillInInfluencerAccessCredits: '请填写达人访问权限和积分信息',
    endorsementPlaceholder: '例如：融资、主要合作伙伴、用户增长、收入...',
    endorsementPlaceholderDesc: '添加亮点，提升达人信任度并增加合作率。',
    brandHighlightsEndorsements: '品牌亮点 & 背书',
    pleaseEnterBusinessIntroduction: '请输入品牌/业务介绍',
    forInfluencerMatching: {
      label: '用于达人匹配',
      tooltip: '此信息有助于 Aha 找到受众和内容与您的营销计划最匹配的达人。',
    },
  },

  // 选择目标
  selectObjective: {
    title: '选择营销目标',
    awareness: '品牌知名度',
    traffic: '流量',
    leads: '线索',
    installs: '安装',
    signUps: '注册',
    sales: '销售',
    // 其他目标相关文本
  },

  // 平台内容标签
  platformContentLabel: {
    youtubeDedicated: 'YouTube 专题视频',
    youtubeIntegrated: 'YouTube 插片视频',
    tiktokVideo: 'TikTok 视频',
    instagramReel: 'Instagram Reels',
    instagramCarouselPost: 'Instagram 轮播贴',
    twitterPost: 'Twitter / X 帖子',
    linkedinPost: 'LinkedIn 帖子',
    linkedinImagePost: 'LinkedIn 图片帖子',
    linkedinVideoPost: 'LinkedIn 视频帖子',
  },

  // 预算出价
  budgetBidding: {
    title: '预算与出价',
    dailyBudget: '日预算',
    totalBudget: '总预算',
    budgetPerInfluencer: '单个达人预算',
    budgetLimitWarning: '请为每位达人设置合理的预算上限。过低或过高都可能影响供给。如不确定，建议选择「智能模式」。',
    chooseBudgetLimit: '选择预算上限',
    maximumCpm: '最大 CPM',
    influencerMarketing: '达人营销',
    totalInfluencerPayment: '达人总费用',
    totalBudgetDescription: '设置您的总预算——您可以随时在活动发布后调整预算。仅在内容交付后才会支付，活动发布后可随时调整预算。',
    pleaseSelectBudgetForInfluencer: '请选择预算',
    name: '姓名',
    followers: '粉丝数',
    estViewsPerPost: '预计播放/条',
    matchReason: '匹配理由',
    profile: '资料',
    view: '查看',
    sampleInfluencersTitle: '可能合作的示例达人',
    sampleInfluencersDesc: '基于您的活动信息，我们预先匹配了部分示例达人，便于评估受众契合度。如不理想，可随时调整活动输入。',
    notSeeingIdealMatches: '没有看到理想匹配？',
    adjustYourInputs: '试试调整筛选条件',
    currentPlan: '当前方案',
    perMonth: '/ 月',
    influencerFee: '达人费用',
    verifyYourAuthorization: '验证授权',
    authorizationDescription: '为确保与 Aha 的授权文件具备法律效力，请填写您的法定全名以完成验证。未通过授权将无法发布活动。',
    fullLegalName: '法定全名',
    fullLegalNamePlaceholder: '例如：John Doe',
    // Influencer application preview related
    influencerApplicationPreview: '达人申请预览',
    actualValuesMayFluctuate: '实际价值可能会因市场动态、影响者供应和相关条件等因素而波动。上面显示的影响者仅供预览和参考；一旦活动发布，将进行最终匹配。',
    // Subscription related
    monthlySubscriptionCancellationRate: '月度订阅流失率',
    pleaseEnterMonthlySubscriptionCancellationRate: '请输入月度订阅流失率',
    industryBenchmarkSubscription: '行业参考：B2B 1%–3%，B2C 5%–10%',
    clickToPurchaseRate: '点击-购买转化率',
    pleaseEnterClickToPurchaseRate: '请输入点击-购买转化率',
    industryBenchmarkClickToPurchase: '行业参考：1%–5%。',
    // Pay-as-you-go related
    clickToPayConversionRate: '点击-支付转化率',
    pleaseEnterClickToPayConversionRate: '请输入点击-支付转化率',
    payingUserARPU: '付费用户 ARPU',
    pleaseEnterPayingUserARPU: '请输入付费用户 ARPU',
    payingUserARPUDescription: '每位付费用户带来的平均收入。',
    // Table column titles
    estimatedPrice: '预估价格',
    predictedCPM: '预测 CPM',
    predictedViews: '预测播放量',
    predictedCPC: '预测 CPC',
    predictedClicks: '预测点击',
    // Landing page URL related
    conversionTrackingAlert: '请确保承接页面已配置转化追踪。转化追踪可帮助评估点击带来的有效行为，并据此优化投放。了解更多：',
    viewHeadDevelopmentDoc: '查看 Aha 开发文档',
    pleaseEnterValidLink: '请输入有效链接',
    landingPagePlaceholder: '用户在观看达人内容后将访问的链接',
    back: '上一步',
    continue: '继续',
    partnershipAuthorization: '合作授权',
    authorizationText1: '确认后，您即',
    authorizationText2: '（由 Ahalab.ai Inc. 运营）代表您管理本次营销计划。',
    authorizationDescription1: '该授权文件将在达人接收任务时显示，提升合作可信度，减少不必要的来回沟通。',
    authorizationDescription2: '多数达人无需进一步确认，',
    authorizationDescription2Highlight: '但也可能有少数达人会直接与您或团队核实。',
    authorizationDescription2End: '您可选择回复或忽略；我们的支持团队会负责后续跟进，确保流程顺畅。',
    reminder: '提醒',
    iConfirmAuthorization: '我确认授权',
    verifyYourBusiness: '验证企业资质',
    sensitiveIndustryNotice: '我们检测到该活动涉及敏感行业。为核验品牌合法性，请上传支持性文件（如营业执照等）。',
    emailMismatchNotice: '我们发现您的工作邮箱与活动网站域名不一致。为确保已获得',
    formalConsentFromBrand: '品牌的正式授权',
    emailMismatchNoticeEnd: '，请上传相关材料，如营业执照、代理协议等。',
    upload: '上传',
    modalBack: '上一步',
    modalContinue: '继续',
    ifYouNeedAssistance: '如需帮助，欢迎',
    contactUs: '联系我们。',
    fileSizeExceedError: '文件大小不可超过 10MB！',
    failedToUploadLogo: 'Logo 上传失败',
    setCpmCap: '设置 CPM 上限',
  },

  // 预览匹配
  previewSampleMatches: {
    title: '示例匹配预览',
    saveSuccess: '保存成功！',
    feedbackTitle: '',
    feedbackDescriptionLoading: '您可以调整匹配准确度、品牌介绍、核心卖点或核心受众，以进一步提高匹配质量。',
    feedbackDescriptionFocusMode: '您正在查看在聚焦模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    feedbackDescriptionScaleMode: '您正在查看在扩展模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    feedbackDescriptionMaxScaleMode: '您正在查看在最大扩展模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    notGettingRightMatches: '没有得到理想的匹配？',
    highNotMatchRateMessage: '超过 40% 的创作者被标记为“不匹配”。这表明您的活动信息中某些部分，如<b>匹配准确度、品牌介绍、核心卖点或核心受众</b>，可能需要 refinement。\n您想让 Aha 自动优化这些部分吗？您的手动编辑将保持不变。',
    moreThan40Percent: '超过 40% 的创作者被标记为',
    notAMatchPeriod: '不匹配。',
    thisUsuallyMeansInfo: '这通常意味着您的活动信息',
    likeAudienceCore: '（如品牌介绍、目标受众、核心卖点或匹配模式等）',
    mayNeedFineTuned: '可能需要微调以提升准确度。现在要检查并优化吗？',
    continueAnyway: '仍然继续',
    editCampaignInfoManually: '手动编辑活动信息',
    optimizeWithAI: '使用 AI 优化',
    matchReason: '匹配理由',
    match: '匹配',
    emptyMessage: '我们正在准备样本匹配以微调您的结果。此过程大约需要 2 分钟。',
    emptyMessage2: '初步测试匹配可在进行完整的 KOL/网红匹配之前验证方向是否正确。',
    emptyMessageTips: '这是一个测试匹配，不是最终匹配结果。',
    endCard: {
      description: '您的初始匹配看起来很棒！基于您的反馈，我们将继续推进到正式匹配阶段，届时将为您匹配最符合目标受众的达人。',
      return: '更新您的反馈',
      notMatchDesc: '为了提高影响者匹配的质量和相关性，我们建议调整您的活动信息。您可以让我们的AI助手立即优化您的广告系列，或',
      notMatchDescLink: '联系我们寻求帮助。',
      next: '下一步',
      expandWithAISuggestions: '使用 AI 优化',
      adjustMatchingAccuracyMode: '调整匹配准确度模式'
    },
    notAMatch: '不匹配',
    emptyMessageTime: '2分钟',
    timeSecond: '秒',
    timeMinute: '分钟',
    timeMinutes: '分钟',
  },

  // 创建估算面板
  createEstimatePanel: {
    estimatedCampaignResults: '营销结果预测',
    affiliateMarketingResultsEstimation: '分销营销结果预测',
    coldEmailResultsEstimation: '邮件营销结果预测',
    views: '播放量',
    cpm: 'CPM',
    clicks: '点击量',
    cpc: 'CPC',
    costPerInstallRange: '单次安装成本范围',
    installRange: '安装量范围',
    costPerLeadRange: '单条线索成本范围',
    leadRange: '线索量范围',
    costPerSignUpRange: '单次注册成本范围',
    signUpRange: '注册量范围',
    roiRange: 'ROI 范围',
    salesRange: '销售额范围',
    arpuCacRange: 'ARPU/CAC 范围',
    aovCacRange: 'AOV/CAC 范围',
    cpmAcrossDifferentPlatforms: '各平台 CPM 对比',
    numberOfAffiliates: '分销达人数量',
    noteSalesEstimates: '说明：销售额估算基于 1.5%–4.5% 的点击-购买转化行业参考。',
    potentialConvertedLeads: '潜在转化线索',
    potentialCustomers: '潜在客户数',
    potentialLifetimeRevenue: '潜在生命周期收入',
    roi: 'ROI',
  },

  // 受众
  audiences: {
    title: '受众',
    // 其他受众相关文本
  },

  // 创意
  creatives: {
    title: '创意',
    // 其他创意相关文本
  },

  // 开发策略
  developStrategy: {
    title: '开发策略',
    // 其他策略相关文本
  },

  // 增长策略
  growthStrategy: {
    title: '增长策略',
    // 其他增长相关文本
  },

  // 活动创意
  campaignIdeas: {
    title: '营销创意',
    // 其他创意相关文本
  },

  // 活动步骤
  campaignSteps: {
    setupCampaign: '设置营销计划',
    basicInformation: '基础信息',
    settings: '设置',
    previewSampleMatches: '示例匹配预览',
    budgetAndResults: '预算与结果',
    enterOtherInformation: '填写其他信息',
    reviewSummary: '审核摘要',
    collapse: '收起',
  },

  // 选择交付模式
  selectDeliveryMode: {
    title: '选择交付模式',
    serviceModel: '服务模式',
    contactUsMessage: '发布前，欢迎联系我们，免费获取一堂达人营销速成课。',
    serviceModelComparison: '服务模式对比',
    // 其他交付模式相关文本
  },

  // 产品分析
  productAnalysis: {
    title: '产品分析',
    // 其他产品分析相关文本
  },

  // 审核摘要
  reviewSummary: {
    title: '审核摘要',
    // 其他审核相关文本
  },

  // 添加Stripe
  addStripe: {
    title: '添加 Stripe',
    // 其他Stripe相关文本
  },

  // 落地页URL
  landingPageUrl: {
    title: '落地页链接',
    // 其他落地页相关文本
  },

  // 其他信息
  otherInformation: {
    title: '其他信息',
    // 其他信息相关文本
  },

  // 进度时间线
  progressTimeline: {
    title: '进度阶段',
    editCampaign: '编辑计划',
    headThinking: 'Aha 正在思考…',
    headFinished: 'Aha 思考完成。',
    noMoreInfluencers: '当前没有更多与您活动匹配度高的达人。如需寻找更多达人，建议调整活动详情；我会基于最新信息继续识别并联络合适达人。',
    // 其他进度相关文本
  },

  // 网站表单
  websiteForm: {
    title: '网站表单',
    welcomeMessage: 'Hi {firstName}！很开心能跟你一起设计真正有效的营销策略，落地一场专家级的 Campaign。把你的 URL 贴进来，我会为你提供一份基础的品牌分析，并在此基础上和你一起进行细化调整。这些信息，也能让我更精准的找到适合你品牌的达人哦～',
    welcomeMessageNoName: 'Hi！很开心能跟你一起设计真正有效的营销策略，落地一场专家级的 Campaign。把你的 URL 贴进来，我会为你提供一份基础的品牌分析，并在此基础上和你一起进行细化调整。这些信息，也能让我更精准的找到适合你品牌的达人哦～',
    pleaseEnterWebsite: '请输入网站地址',
    pleaseEnterValidWebsite: '请输入有效的网站地址',
    websitePlaceholder: '输入产品/应用官网、Amazon 链接、Shopify 链接等',
    generate: '生成',
    errorOccurred: '发生错误，请稍后重试。',
    // 其他网站表单相关文本
  },
  websiteLoading: {
    settingUpCampaign: '设置活动',
    readStory: '查看案例',
  }
};
